import { render, staticRenderFns } from "./PaquetesTimbres.vue?vue&type=template&id=94381eb0&scoped=true"
import script from "./PaquetesTimbres.vue?vue&type=script&lang=js"
export * from "./PaquetesTimbres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94381eb0",
  null
  
)

export default component.exports